export default "__VITE_ASSET__CzpvNjBx__"